// extracted by mini-css-extract-plugin
export default {"fixedbox":"AsideFixedBox_fixedbox__-lPZN"};